import { __awaiter } from "tslib";
import './types/GlobalWindow';
export { Channel, Language, Partner, MessagingTopic } from '@soluto-private/remote-expert-types';
export const injectChatScriptByVersion = ({ id, version, environment }, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const domain = environment === 'development' ? 'solutodev.com' : 'anywhereexpert.us';
    const src = `https://chat-sdk.remoteexpert.${domain}/remote-expert-chat-sdk-${version}.js`;
    yield injectScript({ id, src }, callback);
});
export const injectScript = ({ id, src }, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const existingScript = document.getElementById(id);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        document.body.appendChild(script);
        script.async = false;
        script.onload = () => __awaiter(void 0, void 0, void 0, function* () {
            if (callback)
                yield callback();
        });
    }
    if (existingScript && callback)
        yield callback();
});
export const initialize = (config) => __awaiter(void 0, void 0, void 0, function* () { return yield window.__CHAT_SDK.initialize(config); });
export const updateMessagingTopic = (messagingTopic) => __awaiter(void 0, void 0, void 0, function* () { return window.__CHAT_SDK.updateConfig({ messagingTopic }); });
export const updatePartner = (partner) => __awaiter(void 0, void 0, void 0, function* () { return window.__CHAT_SDK.updateConfig({ partner }); });
export const updateLanguage = (language) => __awaiter(void 0, void 0, void 0, function* () { return window.__CHAT_SDK.updateConfig({ language }); });
export const updateConfig = (config) => __awaiter(void 0, void 0, void 0, function* () { return window.__CHAT_SDK.updateConfig(config); });
export const showChatBubble = () => window.__CHAT_SDK.showChatBubble();
export const hideChatBubble = () => window.__CHAT_SDK.hideChatBubble();
export const expandChatOverlay = (payload) => window.__CHAT_SDK.expandChatOverlay(payload);
export const collapseChatOverlay = () => window.__CHAT_SDK.collapseChatOverlay();
export const attachSDKToContainer = (containerElementId) => window.__CHAT_SDK.attachSDKToContainer(containerElementId);
export const detachSDKFromContainer = () => window.__CHAT_SDK.detachSDKFromContainer();
export const showMessage = (message, autoSend) => window.__CHAT_SDK.showMessage(message, autoSend);
//# sourceMappingURL=api.js.map